import { useNavigate, useSearchParams } from "react-router-dom";
import QueryName from "../../../components/Admin/DatastoreRequests/DataStoreRequestQueryName/QueryName";
import { useEffect } from "react";
import { DataStoreReqEndPointLogic } from "../../../logic/Admin/DataStoreRequest/DataStoreRequestEndPointLogic";
import { useSelector } from "react-redux";
import { selectUserData, selectUserToken } from "../../../features/userSlice";
import { useDispatch } from "react-redux";
import { setEditId, setIsLoading } from "../../../features/dataStoreReqSlice";
import SimpleBackdrop from "../../../components/BackDrop/BackDrop";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import Page404 from "../../../components/Page404/Page403";

const DataStoreReqQueryNameScreen = () => {
  const [searchParams] = useSearchParams();
  const token = useSelector(selectUserToken);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const queryId = searchParams.get("queryId");
  const { isLoading, editCompleted } = useSelector((state: any) => state.dataStoreReq);
  const response = useSelector(selectUserData);
  const hasDataStoreViewPermission = CheckPermissions(
    response?.data?.products?.admin,
    "datastore_requests",
    "view_datastore_requests"
  );

  useEffect(() => {
    const fetchQueryData = async () => {
      if (!queryId) return;

      try {
        dispatch(setIsLoading(true));
        await DataStoreReqEndPointLogic.getBizLayerQueryById(
          token,
          dispatch,
          setIsLoading, // This is Redux's loading state
          queryId,
          navigate
        );
      } catch (error) {
        console.error("Error fetching query data:", error);
      }
    };
    if (hasDataStoreViewPermission) {
      fetchQueryData();
      dispatch(setEditId(queryId));
    } else {
      dispatch(setIsLoading(false));
    }
    // eslint-disable-next-line
  }, [queryId, editCompleted]);

  return (
    <div>
      {isLoading ? (
        <SimpleBackdrop />
      ) : hasDataStoreViewPermission ? (
        <QueryName />
      ) : (
        <Page404 />
      )}
    </div>
  );
};

export default DataStoreReqQueryNameScreen;
